import { createPermissions, hasRole } from 'cesg-shared';
import type { SessionUser } from 'cesg-shared/dist/models';
import { UserRole } from 'cesg-shared/dist/models';
import { computed } from 'vue';

type ButtonState = 'visible' | 'hidden';

export type { ButtonState };

interface UseLiftPlanUEListPermissionsProps {
  projectId: string;
  user: SessionUser;
}

export const useLiftPlanUEListPermissions = ({
  projectId,
  user,
}: UseLiftPlanUEListPermissionsProps) => {
  return computed(() => {
    const permissions = createPermissions(projectId, user);
    return {
      addUEButton: (permissions.edit.overview && hasRole(UserRole.CESG, user)
        ? 'visible'
        : 'hidden') as ButtonState,
    };
  });
};
